export default __webpack_public_path__ + "static/media/previous.70ef691d.svg";